<template lang="pug">
  .nav
    ul
      li.guide
        a(v-bind:href="'https://guide.morecon.jp/'" target="_blank") お買い物ガイド
      li.mail
        a(v-bind:href="buildUrl('pages/mail_magazine/')") メルマガ・割引
      li.fav
        a(v-bind:href="buildUrl('mypage/favorite')") お気に入り
      li.mypage
        a(v-bind:href="buildUrl('mypage/')" v-if="login") マイページ
        a(v-bind:href="buildUrl('mypage/login/')" v-if="!login") 登録・ログイン

</template>
<script>
import CustomerStore from '../../../stores/CustomerStore'
import config from '../../../components/config/Config'

export default {
  name: 'HeaderMenu',
  mixins: [config],
  /**
   * data
   * @returns {{msg: string}}
   */
  data () {
    return {
    }
  },
  /**
   * mounted
   */
  mounted () {
  },
  methods: {
  },
  computed: {
    /**
     * ボタン名を返す
     * @return {string}
     */
    buttonName () {
      return CustomerStore.state.buttonName
    },
    /**
     * ログイン済みかどうか
     * @returns {boolean} ログイン情報
     */
    login () {
      return CustomerStore.state.user.login
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
// .nav {
//   background-color: rgb(30, 148, 108);
//   height: 80px;
// }
ul{
  float: right;
  display: block;

  li{

    float: left;
    display: block;
    width: 100px;
    padding-top: 7px;

    a{
      display: block;
      padding-top: 35px;
      text-align: center;
      font-size: 10px;
      color: #fff;
      text-decoration: none;
      background-repeat: no-repeat;
      background-position: top center;
      &:hover{
        color: #ccc;
      }
    }

    &.guide a{
      background-image: url("../../../../static/images/pc/header/guide_off.png");
    }
    &.mail a{
      background-image: url("../../../../static/images/pc/header/mail_off.png");
    }
    &.fav a{
      background-image: url("../../../../static/images/pc/header/fav_off.png");
    }
    &.mypage a{
      background-image: url("../../../../static/images/pc/header/mypage_off.png");
    }

    &.guide a:hover{
      background-image: url("../../../../static/images/pc/header/guide_on.png");
    }
    &.mail a:hover{
      background-image: url("../../../../static/images/pc/header/mail_on.png");
    }
    &.fav a:hover{
      background-image: url("../../../../static/images/pc/header/fav_on.png");
    }
    &.mypage a:hover{
      background-image: url("../../../../static/images/pc/header/mypage_on.png");
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pc/common/HeaderMenu.vue